export default {
  accessToken: import.meta.env.VITE_ROLLBAR_ACCESS_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  scrubFields: [
    'password',
    'token',
    'secret',
    'api_key',
    'authorization',
    'cookie',
    'csrf_token',
  ],
  payload: {
    environment: import.meta.env.MODE || 'development',
    client: {
      javascript: {
        code_version: import.meta.env.VITE_BUILD_VERSION || '1.0.0',
        source_map_enabled: true,
      },
    },
  },
}
